import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../customAxios/Axios";
import { useLoader } from "@/context/loaderContext";

import { useTimerContext } from "@/context/TimerContext";
import QuestionCountCard from "../QuestionCountCard";
import AssessmentLableAndTimer from "../AssessmentLableAndTimer";
import AssessmentProgressBar from "../AssessmentProgressBar";
// import Timer from "./Timer";

interface QuestionProps {
	candidate_id: string;
	questions: any[];
	currentIndex: number;
	setCurrentIndex: React.Dispatch<React.SetStateAction<number>>;
	jobId: string;
}

const McqMain: React.FC<QuestionProps> = ({
	candidate_id,
	questions,
	currentIndex,
	setCurrentIndex,
	jobId,
}: QuestionProps) => {
	const { setLoading } = useLoader();

	const [selectedOptions, setSelectedOptions] = useState<{
		[key: number]: string;
	}>({});
	const { timeLeft, setTimeLeft, isTimeUp, setIsTimeUp, setIsPaused } =
		useTimerContext();
	const [isSubmitting, setIsSubmitting] = useState(false);
	const navigate = useNavigate();

	useEffect(() => {
		setTimeLeft(60);
	}, []);

	useEffect(() => {
		localStorage.setItem(
			"question_id",
			JSON.stringify(questions[currentIndex].tech_ques_id)
		);
		setSelectedOptions({});
	}, []);

	const handleOptionChange = (value: string) => {
		setSelectedOptions((prevOptions) => ({
			...prevOptions,
			[currentIndex]: value,
		}));
	};

	const submitMcq = async () => {
		setLoading(true);
		setIsPaused(true);
		setIsSubmitting(true);
		const payload = {
			candidate_id: candidate_id,
			job_id: jobId,
			answers: questions.map((question, index) => ({
				user_answer: selectedOptions[index] || "",
				question_id: question.tech_ques_id,
			})),
		};
		try {
			const resp = await api.post("/store_tech_response", payload);
			if (resp.status === 200) {
				setIsPaused(false);
				setIsTimeUp(false);
				setTimeLeft(60);
				setLoading(false);
				const assessmentData = JSON.parse(
					sessionStorage.getItem("question") || ""
				);

				delete assessmentData?.tech_questions;
				sessionStorage.setItem("question", JSON.stringify(assessmentData));
				sessionStorage.setItem("assessmentSection", "coding");
				navigate("/highlights");
			} else {
				setLoading(false);
				alert("Error submitting answers");
			}
		} catch (error) {
			setLoading(false);

			alert("Error submitting answers");
		} finally {
			setIsSubmitting(false);
			setLoading(false);
		}
	};
	const nextbtn = () => {
		if (currentIndex < questions.length - 1) {
			setCurrentIndex((prevIndex) => prevIndex + 1);

			setTimeLeft(60);
			setIsTimeUp(false);
		} else {
			submitMcq();
		}
	};

	// Check if all questions have been answered

	useEffect(() => {
		if (isTimeUp) {
			nextbtn();
		}
	}, [isTimeUp]);

	return (
		<div className="mt-3 mx-5">
			<AssessmentProgressBar current={currentIndex} total={questions.length} />
			{questions ? (
				<div className="h-full flex justify-center gap-5 items-start mt-3">
					<div className="w-[90%] mx-3 rounded-xl ">
						<div className="border-1 rounded-xl">
							<AssessmentLableAndTimer
								timeLeft={timeLeft}
								label="Technical Assessment"
							/>
						</div>

						<div className="bg-white px-3 text-sm flex justify-between gap-5 py-3">
							<div>
								<h2 className="  text-lg">
									{currentIndex + 1 + ".  "}
									{questions[currentIndex].question}
								</h2>
								<form>
									{Object.entries<string>(questions[currentIndex].options).map(
										([key, value]) => (
											<div
												key={key}
												className="my-4  p-2 rounded  font-body text-lg"
											>
												<label className="flex items-center gap-2">
													<div className="flex items-center gap-1">
														<input
															type="radio"
															name={`question-${currentIndex}`}
															value={key}
															checked={selectedOptions[currentIndex] === key}
															onChange={() => handleOptionChange(key)}
															className=" w-5 h-5 rounded-none border-gray-300 "
														/>

														<span className=" font-semibold">{key}.</span>
													</div>
													<div className=" border-1 rounded-xl p-2 w-full">
														{value}
													</div>
												</label>
											</div>
										)
									)}
								</form>
							</div>
							<div></div>
						</div>

						<div className="flex justify-center my-4">
							{currentIndex !== questions.length - 1 ? (
								<button
									className={`font-body text-white px-4 py-2 rounded-md ml-4 ${!selectedOptions[currentIndex]
											? "bg-gray-500 cursor-not-allowed"
											: "bg-black text-white "
										}`}
									onClick={nextbtn}
									disabled={!selectedOptions[currentIndex]}
								>
									Next Question
								</button>
							) : (
								<div className="flex justify-end ">
									<button
										className={`font-body text-white px-4 py-2 rounded-md ml-4 ${!selectedOptions[currentIndex]
												? "bg-gray-500 cursor-not-allowed"
												: "bg-black text-white "
											}`}
										onClick={submitMcq}
									>
										{isSubmitting ? "Submitting..." : "Submit"}
									</button>
								</div>
							)}
						</div>
					</div>
					<div>
						<QuestionCountCard
							selectedAnsawer={selectedOptions}
							currentQuestionIndex={currentIndex}
							totalQuestion={questions.length}
						></QuestionCountCard>
					</div>
				</div>
			) : (
				<div>Loading questions...</div>
			)}
		</div>
	);
};

export default McqMain;
